import { render, staticRenderFns } from "./MyHomePage.vue?vue&type=template&id=4d3c5806&scoped=true&"
import script from "./MyHomePage.vue?vue&type=script&lang=js&"
export * from "./MyHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3c5806",
  null
  
)

export default component.exports